import { useState } from "react";
import { InlineAlert, LoadingSpinner } from "../../components/BaseComponents";
import ConfirmationModal from "../../components/BaseComponents/ConfirmationModal";
import useApi from "../../hooks/useApi";
import { getApiErrorMessage, getCSRFToken } from "../../lib/utils";

type DeletePortfolioModalProps = {
    onClose: () => void,
    onDeleted: () => void
    isOpen?: boolean,
    portfolioId: string,
    portfolioName: string;
};

function DeletePortfolioModal({onClose, onDeleted, isOpen, portfolioId, portfolioName}: DeletePortfolioModalProps) {
    const api = useApi();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Issue #884: this DELETE is behind RequireWriteAccess, so it can now reject with
    // READ_ONLY_ACCESS/ACCESS_AUDIT_UNAVAILABLE (#857 item 6) as well as any generic failure.
    // setLoading(false) previously only ran after the awaited call succeeded, so a rejection left
    // `loading` (and its spinner) stuck true forever with no visible error. onDeleted() was never
    // reachable after a throw, so there was no false success - but nothing told the user it failed.
    const deletePortfolio = async () => {
        setLoading(true);
        setError('');
        try {
            await api.delete(`/portfolios/${portfolioId}`, {
                _csrf: await getCSRFToken(),
            })
            onDeleted();
        } catch (err: any) {
            setError(getApiErrorMessage(err, 'Failed to delete this portfolio. Please try again.'));
        } finally {
            setLoading(false);
        }
    }


    return (
        <ConfirmationModal open={!!isOpen} onCancel={onClose} onConfirm={deletePortfolio} title={`Delete portfolio ${portfolioName}?`}>
            { loading && <LoadingSpinner /> }
            { error && (
                <InlineAlert type='error' className='mt-4'>{ error }
                </InlineAlert>
            )}
        </ConfirmationModal>
    )
}

export default DeletePortfolioModal;
